export const messagesAnalytics = {
	pageTitle: "Relatório de mensagens",
	pageSubtitle: "Acompanhe volume e origens dos disparos de SMS na organização.",
	filters: {
		dateRange: "Período",
		origin: "Origem",
		place: "Local",
		event: "Evento",
		allOrigins: "Filtrar por origem",
		allPlaces: "Filtrar por Local",
		placesLabel: "Local",
		originsLabel: "Origem",
		allEvents: "Filtrar por Evento",
	},
	cards: {
		totalSent: "Total Enviado",
		activePlaces: "Locais com Disparos",
		eventsWithMessages: "Eventos com Disparo",
		distinctOrigins: "Origens Distintas",
		vsPreviousPeriod: "vs período anterior",
		ofRegistered: "de {{total}} cadastrados",
		distinctOriginsCount: "{{count}} origens distintas",
		deliveryStatus: "Status de Entrega",
		delivered: "Entregues",
		failed: "Falhas",
		successRate: "Taxa de Sucesso",
	},
	charts: {
		byOrigin: "SMS por origem",
		byPlace: "SMS por local",
		dailyVolume: "Volume diário de envios",
		totalDispatches: "Total de disparos",
		showAll: "Ver todos ({{count}})",
		showLess: "Ver menos",
		deliveryStatus: "Status de entrega",
		successRate: "Taxa de sucesso",
	},
	ranking: {
		title: "Maiores disparos no período",
	},
	origins: {
		npsForm: "Pesquisa de satisfação (NPS)",
		giftback: "Giftback",
		campaignMessage: "Envio de Mensagens",
		givePromotion: "Promoção",
		digitalCashlessRechargeLowBalanceSms: "SMS de recarga (saldo baixo cashless digital)",
		withdrawRequest: "Confirmação de solicitação de saque",
		pdvPaymentReceipt: "Comprovante de pagamento PDV",
		loyaltyProgramCreated: "Programa de Fidelidade",
		coalaIntegration: "Delivery",
		kitchen: "Grab&Go (Aplicativo B2C)",
		reservation_confirmation: "Confirmação de Reserva",
		minimumStorageAlert: "Alerta de Estoque Mínimo",
		reservation_late: "Reserva Atrasada",
		reservation_day_of: "Lembrete de Reserva (dia)",
		reservation_reminder: "Lembrete de Reserva",
		reservation_cancellation: "Cancelamento de Reserva",
	},
	originCategories: {
		npsForm: "NPS",
		giftback: "Cashback",
		campaignMessage: "Campanha",
		givePromotion: "Promoção",
		digitalCashlessRechargeLowBalanceSms: "Recarga",
		withdrawRequest: "Financeiro",
		pdvPaymentReceipt: "PDV",
		loyaltyProgramCreated: "Fidelidade",
		coalaIntegration: "Integração",
		kitchen: "Integração",
		reservation_confirmation: "Reserva",
		minimumStorageAlert: "Estoque",
		reservation_late: "Reserva",
		reservation_day_of: "Reserva",
		reservation_reminder: "Reserva",
		reservation_cancellation: "Reserva",
	},
	tabs: {
		charts: "Visão Geral",
		list: "Listagem",
	},
	table: {
		date: "Data",
		place: "Local",
		event: "Evento",
		origin: "Origem",
		smsCount: "SMS Enviados",
		deliveredCount: "Entregues",
		failedCount: "Falhas",
		successRate: "Taxa de Sucesso",
		total: "Total",
		resultsPerPage: "Resultados por página",
	},
	noData: "Sem dados para o período selecionado",
};
